import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import IMGlogo from "../../assets/imagine-logo.png";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  menuClasses,
} from "react-pro-sidebar";
import "../Maincomp/Maincomp.css";
import { SidebarHeader } from "../SidebarHeader";
import { auth } from "../../firebase/config";
import { signOut } from "firebase/auth";

// MUI Icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import TaskIcon from "@mui/icons-material/Task";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PeopleIcon from "@mui/icons-material/People";
import LogoutButton from "../LogoutButton/LogoutButton";

import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Typography } from "@mui/material";
import { useAuth } from "../../context/useAuth";
import { AuthContext } from "../../context/AuthContext";
import {
  Alarm,
  Margin,
  Padding,
  SecurityUpdateGoodRounded,
} from "@mui/icons-material";
import useWindowSize from "../../hooks/useWindowSize";


// import StyledButton from "../common/StyledButton";

const themes = {
  light: {
    sidebar: {
      backgroundColor:
        "linear-gradient( to bottom,rgba(255, 0, 0, 0) 0%,rgba(255, 0, 0, 0.5) 40%,rgba(255, 0, 0, 0.8) 60%,red 100%);",
      color: "#607489",
    },
    menu: {
      menuContent: "white",
      icon: "white",
      hover: {
        backgroundColor: "#000000",
        color: "#f20014",
      },
      disabled: {
        color: "#f20014",
      },
    },
  },
  dark: {
    sidebar: {
      backgroundColor:
        "linear-gradient( to bottom,rgba(255, 0, 0, 0) 0%,rgba(255, 0, 0, 0.5) 40%,rgba(255, 0, 0, 0.8) 60%,red 100%);",
      color: "#8ba1b7",
    },
    menu: {
      menuContent: "white",
      icon: "#white",
      hover: {
        backgroundColor: "#ffffff",
        color: "#f20014",
      },
      disabled: {
        color: "#f20014",
      },
    },
  },
};

// Hex to RGBA converter
const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
function Maincomp({ content }) {
  return (
    <div
      style={{
        width: "100%",
        height: "98.3vh",
        display: "flex",
        color: "white",
      }}
      className="Maindiv-mc"
    >
      <SideMenu />

      <div style={{ width: "100%" }}>
        <div className="slog-mc">
          <p style={{ textAlign: "right", fontSize: "1.6rem" }}>
            INNOVATION | ENTERTAINMENT | SUSTAINABILITY
          </p>
          <Nav />
        </div>


        <div className="d-content-mc">
          <div className="d-data-mc">{content}</div>
        </div>
      </div>
    </div>
  );
}

export default Maincomp;

function SideMenu() {
  const [collapsed, setCollapsed] = useState(true);
  const [toggled, setToggled] = useState(false);
  const [broken, setBroken] = useState(false);
  const [rtl] = useState(false);
  const [hasImage] = useState(true);
  const [theme] = useState("light");

  
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  
  const menuItemStyles = {
    root: {
      fontSize: "16px",
      fontWeight: 400,
    },
    icon: {
      color: themes[theme].menu.icon,
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
    },
    SubMenuExpandIcon: {
      color: "#ffffff",
    },
    subMenuContent: ({ level }) => ({
      backgroundColor:
        level === 0
          ? hexToRgba(
              themes[theme].menu.menuContent,
              hasImage && !collapsed ? 0.6 : 1
            )
          : "transparent",
    }),
    button: {
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      "&:hover": {
        backgroundColor: hexToRgba(
          themes[theme].menu.hover.backgroundColor,
          hasImage ? 0.8 : 1
        ),
        color: themes[theme].menu.hover.color,
      },
      borderRadius: "10px",
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : 700,
    }),
  };
  const navigate = useNavigate();

  const [value, setValue] = useState(["default"]);
  const { role } = useContext(AuthContext);
  const {width}=useWindowSize();

  return (
    <Sidebar
      collapsed={collapsed}
      toggled={toggled}
      onBackdropClick={() => setToggled(false)}
      onBreakPoint={setBroken}
      rtl={rtl}
      breakPoint="md"
      rootStyles={{
        color: themes[theme].sidebar.color,
        // marginLeft:"250px",
      }}
      backgroundColor={
        "black"
      }
    >
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <SidebarHeader
          rtl={rtl}
          style={{ marginBottom: "24px", marginTop: "16px" }}
        />

        <div style={{ flex: 1, marginBottom: "32px" }}>
          <div
            style={{
              borderRadius: "50%",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "40px",
            }}
          ></div>

          <Menu menuItemStyles={menuItemStyles}>
            {/* avatar  */}

            <MenuItem
              icon={
                <img
                  src={`https://avatar.iran.liara.run/username?username=${role}`}
                  alt="role"
                />
              }
              style={{ marginBottom: "40px", marginTop: "-30px" }}
            >
              {role}
            </MenuItem>

            <MenuItem
              onClick={() => navigate("/stats")}
              icon={<DashboardIcon />}
            >
              Dashboard
            </MenuItem>
            <SubMenu label="Inventory" icon={<InventoryIcon />}>
              <MenuItem onClick={() => navigate("/all-inventory")}>
                All Inventory
              </MenuItem>
              <MenuItem onClick={() => navigate("/inventory")}>
                Add Inventory
              </MenuItem>
            </SubMenu>
            <MenuItem
              onClick={() => navigate("/selling-details")}
              icon={<TaskIcon />}
            >
              Transactions
            </MenuItem>
            <SubMenu label="Mangae Users" icon={<PeopleIcon />}>
              <MenuItem onClick={() => navigate("/all-retailer")}>
                Retailers
              </MenuItem>
              <MenuItem onClick={() => navigate("/all-distributor")}>
                Distributor
              </MenuItem>
              <MenuItem onClick={() => navigate("/all-super-stockist")}>
                Super Stockist
              </MenuItem>
              <MenuItem onClick={() => navigate("/create-user")}>
                Create User
              </MenuItem>
            </SubMenu>

              <MenuItem icon={<SecurityUpdateGoodRounded />} onClick={()=>navigate("/warranty")} >All Warranty</MenuItem>
        
      
            <MenuItem
              onClick={() => navigate("/billing")}
              icon={<ReceiptLongIcon />}
            >
              Billing
            </MenuItem>

            <MenuItem
              onClick={() => navigate("/product-details")}
              icon={<PhoneIphoneIcon />}
            >
              Search Product
            </MenuItem>


            <MenuItem icon={<LogoutButton/>} onClick={()=>handleLogout()}>
             Logout </MenuItem>

       {width>1200?(    <MenuItem
              onClick={() => setCollapsed(!collapsed)}
              icon={collapsed ? <ClearAllIcon /> : <CloseIcon />}
            >
              {!collapsed && "Collapsed"}
            </MenuItem>
):<></>}
        
          </Menu>
        </div>
        {/* <SidebarFooter collapsed={collapsed} /> */}
      </div>
    </Sidebar>
  );
}

function Nav() {
  return (
    <div className="Nav-mc">
      <img src={IMGlogo} alt="" style={{ width: "20em", marginTop: "-20px" }} />
      <span style={{ fontSize: "25px", marginRight: "20px" }}>
        Let's be the change
      </span>
    </div>
  );
}
